import { render, staticRenderFns } from "./ChatItemPhoto.vue?vue&type=template&id=4e2a92ec&scoped=true"
import script from "./ChatItemPhoto.vue?vue&type=script&lang=js"
export * from "./ChatItemPhoto.vue?vue&type=script&lang=js"
import style0 from "./ChatItemPhoto.vue?vue&type=style&index=0&id=4e2a92ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a92ec",
  null
  
)

export default component.exports